export default class Order {
  private readonly _id: string;
  private readonly _words: Number;
  private readonly _pages: Number;
  private readonly _term: Number;
  private readonly _numberOfSources: Number;
  private readonly _hasProofreadingAndEditing: boolean;
  private readonly _hasReferenceCheck: boolean;
  private readonly _isProofreading: boolean;
  private readonly _isEssayEditing: boolean;
  private readonly _isAIProofreader: boolean;
  private readonly _isExpertReview: boolean;
  private readonly _isPlagiarism: boolean;
  private readonly _deadline: Date | null;
  constructor({
                id,
                words,
                pages,
                term,
                numberOfSources,
                hasProofreadingAndEditing,
                hasReferenceCheck,
                isProofreading,
                isEssayEditing,
                isAIProofreader,
                isExpertReview,
                isPlagiarism,
                deadline,
              }) {
    this._id = id;
    this._words = words;
    this._pages = pages;
    this._term = term;
    this._numberOfSources = numberOfSources;
    this._hasProofreadingAndEditing = hasProofreadingAndEditing;
    this._hasReferenceCheck = hasReferenceCheck;
    this._isProofreading = isProofreading;
    this._isEssayEditing = isEssayEditing;
    this._isAIProofreader = isAIProofreader;
    this._isExpertReview = isExpertReview;
    this._isPlagiarism = isPlagiarism;
    this._deadline = deadline ? new Date(deadline) : null;
  }

  get id(): string {
    return this._id;
  }

  get pages(): Number {
    return this._pages;
  }

  get term(): Number {
    return this._term;
  }

  get words(): Number {
    return this._words;
  }

  get numberOfSources(): Number {
    return this._numberOfSources;
  }

  get hasProofreadingAndEditing(): Boolean {
    return this._hasProofreadingAndEditing;
  }

  get hasReferenceCheck(): Boolean {
    return this._hasReferenceCheck;
  }

  get isProofreading(): Boolean {
    return this._isProofreading;
  }

  get isEssayEditing(): Boolean {
    return this._isEssayEditing;
  }

  get isAIProofreader(): Boolean {
    return this._isAIProofreader;
  }

  get isExpertReview(): Boolean {
    return this._isExpertReview;
  }

  get isPlagiarism(): Boolean {
    return this._isPlagiarism;
  }

  get deadline(): Date | null {
    return this._deadline;
  }
}
